var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.705771 4.78867L8 0.57735L15.2942 4.78867V13.2113L8 17.4227L0.705771 13.2113V4.78867Z",
    stroke: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonSmall);
export default __webpack_public_path__ + "static/media/polygon-small.658225c5bf277cc29b268c259316d105.svg";
export { ForwardRef as ReactComponent };